import axios from 'axios';
import { UserRoles } from '../models/enums/UserRoles';
import { CurrentUser } from '../models/User';
import { InfluencerResponse } from '../models/Influencer';

export const getCurrentUser = async (): Promise<CurrentUser> => {
    const { data } = await axios.get('user/profile');

    const { ...other } = data.data;
    return { ...other, role: data.data.user_role === 0 ? UserRoles.VIEWER : UserRoles.INFLUENCER };
};

export const getInfluencerProfile = async (): Promise<InfluencerResponse> => {
    const { data } = await axios.get('influencer/profile');
    return data;
};

export const getCurrentUserProfile = async (): Promise<unknown> => {
    const { data } = await axios.get('user/profile');
    return data;
};

export const editCurrentUserProfile = async (userProfile: unknown): Promise<unknown> => {
    const { data } = await axios.put('users/current/profile', userProfile);
    return data;
};
